import { Box, Button, CircularProgress, MenuItem, TextField, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useAuth } from "../../../../../auth/auth";
import { addUser, getRoles } from "../../../../../api/apiCall";
import AccessForbidden from "../../../../Access/AccessForbidden";
import Loading from "../../../../../components/Loading/Loading";

type FormValues = {
    name: string;
    surname: string;
    pts: string;
    username: string;
    phoneNumber: string;
    email: string;
    postCode: string;
    password: string;
    roleId: any;
    location: any;
}

const CreateWorker = ({menuClicked, setMenuClicked}: any) => {
    const {state} = useAuth();
    const [buttonLoading, setButtonLoading] = useState(false);
    const [roles, setRoles] = useState<any>([]);
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    const {register, handleSubmit, reset, setValue, formState: { errors }} = useForm<FormValues>();

    const handleCreateWorker = async (data: any) => {
        setButtonLoading(true);
        const response = await addUser(state.user?.token, data);
        if(response?.status === 200) {
            setTimeout(() => {
                setButtonLoading(false);
                toast.success('Worker added successfully');
                reset({
                    name: '',
                    surname: '',
                    pts: 'N/A',
                    phoneNumber: '',
                    email: 'N/A',
                    postCode: 'N/A',
                    username: '',
                    roleId: '',
                });
                setMenuClicked('ManageUsers')
            }, 500);
        } else {
            setButtonLoading(false);
            toast.error('Something went wrong!');
        }
    };

    const getAllRoles = async () => {
        const response = await getRoles(state.user?.token);
        if(response) {
            setRoles(response);
        }
        else {
            setIsAdmin(true);
        }
        setLoading(false);
    }

    useEffect(() => {
        getAllRoles()
    }, []);

    if(loading) {
        return <Loading />;
    }

    if(isAdmin) {
        return <AccessForbidden />;
    }

    return (
        <Box sx={{ margin: "auto", backgroundColor: "#f2f5fc", padding: 5 }}>
            <Box sx={{ maxWidth: 650, margin: "auto", backgroundColor: "#fff", padding: 5 }}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Create New Account
                </Typography>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }} />

                <Box display="grid" gridTemplateColumns={{ xs: "1fr" }} gap={3} mt={7}>
                    <TextField label="Name" variant="outlined" fullWidth size="small" {...register("name")} />
                    <TextField label="Surname" variant="outlined" fullWidth size="small" {...register("surname")} />
                    <TextField label="Username" variant="outlined" fullWidth size="small" {...register("username")} />
                    <TextField label="PTS" variant="outlined" fullWidth size="small" {...register("pts")} defaultValue={"N/A"} />
                    <TextField label="Phone Number" variant="outlined" fullWidth size="small" {...register("phoneNumber")} />
                    <TextField
                        label="Email"
                        variant="outlined"
                        fullWidth
                        size="small"
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        {...register("email" , {
                            required: "Email is required",
                            pattern: {
                                value: /^(?:N\/A|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
                                message: "Please enter a valid email address or N/A"
                            }
                        })}
                        defaultValue={"N/A"}
                    />
                    <TextField
                        label="Post Code"
                        variant="outlined"
                        fullWidth
                        size="small"
                        defaultValue={"N/A"}
                        error={!!errors.postCode}
                        helperText={errors.postCode?.message}
                        {...register("postCode", {
                            pattern: {
                                value: /^(N\/A|[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2})$/i,
                                message: "Please enter a valid UK postcode or N/A"
                            }
                        })}
                        onBlur={(e) => {
                            const value = e.target.value.toUpperCase();
                            setValue("postCode", value);
                        }}
                    />
                    <TextField label="Location" variant="outlined" fullWidth size="small" {...register("location")} />
                    <TextField
                        select
                        label="Role"
                        id="demo-select-small"
                        size="small"
                        fullWidth
                        {...register("roleId")}
                    >
                        {roles.map((role: any) =>
                            <MenuItem key={role.id} value={role.id}>
                                {role.roleName}
                            </MenuItem>
                        )}
                    </TextField>
                </Box>

                <Box display="flex" justifyContent="center" mt={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{boxShadow: "none", backgroundColor: "#156bc2", width: 200}}
                        disabled={buttonLoading}
                        onClick={handleSubmit(handleCreateWorker)}
                    >
                        {buttonLoading ? (
                            <CircularProgress size={25} style={{color: 'white'}} />
                        ) : "Create User"}
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default CreateWorker;